import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense';

const TranslationMode = withSuspense(lazy(() => import('./TranslationMode.jsx')), () => null);

export default TranslationMode;
